import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container sub_page _intro" }
const _hoisted_2 = { class: "sub_page_tit" }
const _hoisted_3 = { class: "sub_menu_tab wrap_1120" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_platform = _resolveComponent("platform")!
  const _component_centerIntroduce = _resolveComponent("centerIntroduce")!
  const _component_FaqList = _resolveComponent("FaqList")!
  const _component_Footer = _resolveComponent("Footer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Header),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("section", _hoisted_2, [
        _cache[7] || (_cache[7] = _createStaticVNode("<div class=\"deco_wrap\"><i class=\"deco_01 _xsmall spin3\"><img src=\"img/b_icon_03.png\"></i><i class=\"deco_02 _small blink_zoom1\"><img src=\"img/b_icon_01.png\"></i><i class=\"deco_03 _xsmall spin_blink2\"><img src=\"img/b_icon_03.png\"></i><i class=\"deco_04 _small blink_blink3\"><img src=\"img/b_icon_01.png\"></i><i class=\"deco_character\"><img src=\"img/intro_icon.png\"></i></div><div class=\"banner_wrap wrap_1120\"><h2>소개</h2></div>", 2)),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("button", {
            class: _normalizeClass(["only_768", { active: $setup.state.subMenuOpen }]),
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.subMenuTab && $setup.subMenuTab(...args)))
          }, _toDisplayString($setup.state.subMenuName), 3),
          _createElementVNode("ul", {
            class: _normalizeClass({ active: $setup.state.subMenuOpen })
          }, [
            _createElementVNode("li", {
              onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.changeTab(1))),
              class: _normalizeClass([$setup.state.tab === 1 ? 'active' : ''])
            }, [...(_cache[4] || (_cache[4] = [
              _createElementVNode("a", { href: "javascript:void(0)" }, "반성매매 시민참여 플랫폼", -1)
            ]))], 2),
            _createElementVNode("li", {
              onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.changeTab(2))),
              class: _normalizeClass([$setup.state.tab === 2 ? 'active' : ''])
            }, [...(_cache[5] || (_cache[5] = [
              _createElementVNode("a", { href: "javascript:void(0)" }, "다시함께상담센터", -1)
            ]))], 2),
            _createElementVNode("li", {
              onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.changeTab(3))),
              class: _normalizeClass([$setup.state.tab === 3 ? 'active' : ''])
            }, [...(_cache[6] || (_cache[6] = [
              _createElementVNode("a", { href: "javascript:void(0)" }, "자주 묻는 질문", -1)
            ]))], 2)
          ], 2)
        ])
      ]),
      ($setup.state.tab === 1)
        ? (_openBlock(), _createBlock(_component_platform, { key: 0 }))
        : _createCommentVNode("", true),
      ($setup.state.tab === 2)
        ? (_openBlock(), _createBlock(_component_centerIntroduce, { key: 1 }))
        : _createCommentVNode("", true),
      ($setup.state.tab === 3)
        ? (_openBlock(), _createBlock(_component_FaqList, { key: 2 }))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_Footer)
  ], 64))
}